/**
 * Branded (opaque) types for chain identifiers and token references.
 *
 * These types are nominally distinct at compile time (you cannot pass a Caip2Id
 * where a ChainNamespace is expected) but have zero runtime cost — they are
 * just strings with a phantom brand.
 *
 * Use the constructor functions (caip2Id, chainNamespace, etc.) at data
 * boundaries to validate and tag incoming strings.
 */
// ---------------------------------------------------------------------------
// Constructors with runtime validation
// ---------------------------------------------------------------------------
const CAIP2_REGEX = /^[-a-z0-9]{3,8}:[-_a-zA-Z0-9]{1,64}$/;
export function caip2Id(value) {
    if (!CAIP2_REGEX.test(value)) {
        throw new Error(`Invalid CAIP-2 ID: "${value}". Expected format "namespace:reference" (e.g. "eip155:1").`);
    }
    return value;
}
export function chainNamespace(value) {
    if (value.includes(':')) {
        throw new Error(`Invalid chain namespace: "${value}". ` +
            `This looks like a CAIP-2 ID. Use parseCaip2Id() to extract the namespace.`);
    }
    return value;
}
export function chainReference(value) {
    return value;
}
export function parseCaip2Id(id) {
    const colonIndex = id.indexOf(':');
    return {
        namespace: id.slice(0, colonIndex),
        reference: id.slice(colonIndex + 1),
    };
}
